/* eslint-disable */

class ConversionNew {
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$conversionNew = this.sectionsContainer.querySelectorAll('.conversion-new');
		
		if (!this.$conversionNew.length) return;
		
		this.$conversionNewElements = [];
		this.$conversionNewButtons = [];

		this.$conversionNew.forEach(module => {
			this.$conversionNewElements.push(module.querySelectorAll('.anima'));
			this.$conversionNewButtons.push(module.querySelector('.buttonAnima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$conversionNew.forEach((module, index) => {
			gsap.set(module, { opacity: 0.0001 });
			gsap.set(this.$conversionNewElements[index], { yPercent: 20, opacity: 0.0001, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.animateconversionNew = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$conversionNew[index],
				start: 'top 70%'
			},
			onComplete: () => {
				gsap.set(this.$conversionNewElements[index], { clearProps: true });
			}
        });
    
        this.animateconversionNew.addLabel('step1');
        this.animateconversionNew.to(this.$conversionNew[index], { opacity: 1 }, 'step1');
		this.animateconversionNew.to(this.$conversionNewElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default ConversionNew;
